<script lang="ts">
	import Icon from './Icon.svelte';

	let {
		title,
		description,
		actionText,
		actionIcon = 'plus',
		onAction,
		class: className = ''
	}: {
		title: string;
		description?: string;
		actionText?: string;
		actionIcon?: string;
		onAction?: () => void;
		class?: string;
	} = $props();
</script>

<div class="mb-8 {className}">
	<div class="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
		<div>
			<h1 class="text-3xl font-bold text-gray-900">{title}</h1>
			{#if description}
				<p class="mt-2 text-gray-600">{description}</p>
			{/if}
		</div>
		{#if actionText && onAction}
			<button
				onclick={onAction}
				class="inline-flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
			>
				<Icon name={actionIcon} size={20} />
				{actionText}
			</button>
		{/if}
	</div>
</div>
